export default __webpack_public_path__ + "9bec8f665f9eb19ea15f60e0208c1787.png";